import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  decrypt,
  toAbsoluteUrl,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { Link, useLocation } from "react-router-dom";
import ArticleSkeleton from "../article/ArticleSkeleton";
import { ToastContainer } from "react-toastify";
import { getCookie } from "../../helpers/CookieComponent";

const VideoList = ({ id, type, date, authorId, deliveredAt }) => {
  ChangeTitle("Videos");
  const [articleList, setArticleList] = useState([]);
  const [articleListEmptyMsg, setArticleListEmptyMsg] = useState("");
  const auth = decrypt(getCookie("token")) || "";

  // Article List API Call
  const viewVideoList = async (id, type, date, authorId, deliveredAt) => {
    const param = {
      articleCategoryId: id,
      articleType: type,
      limit: 5,
      offset: 0,
      date: date || "",
      author: authorId || "",
      deliveredAt: deliveredAt || "",
    };
    var response = await postData("article/list/user", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const categoryData = data.map((data) => {
        return {
          id: data._id,
          title: data.title,
          author: data.author,
          deliveredAt: data.deliveredAt,
          heading: data.heading,
          articleDocument: data.articleDocument,
          description: data.description,
          articleType: data.articleType,
          categoryName: data.categoryName,
          publishDate: data.publishDate,
          view: data.view,
          articleDocument: data.articleDocument,
        };
      });
      const message = response.data.message;
      if (data.length === 0) {
        setArticleListEmptyMsg(message);
      } else {
        setArticleListEmptyMsg("");
      }
      setArticleList(categoryData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewVideoList(id, type, date, authorId, deliveredAt);
  }, [id, type, date, authorId, deliveredAt]);

  // Video Viewer Add API Call
  const addVideoViewer = async (videoId) => {
    if (!auth) return;
    const param = {
      articleId: videoId,
    };
    await postData("private/article/viewer/add", param, apiHeader(false));
  };

  return (
    <>
      <ToastContainer />
      <div className="w-full flex flex-col gap-10 lg:gap-20 justify-center items-center sec-articles">
        {/* {[...Array(5)].map((data) => (
          <div className="w-full lg:w-[90%] xl:w-[80%] p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sec-articles-box">
            <div className="w-full md:w-[75%] lg:w-[80%] xl:w-[83%] flex gap-5 lg:gap-10">
              <div className="md:w-[20%] lg:w-[20%] xl:w-[15%] flex items-start md:items-center md:justify-center h-auto ">
                <div className="sab-part1 md:h-full md:w-full hidden md:flex md:items-center md:justify-center p-[5%]">
                  <img
                    className=""
                    src={toAbsoluteUrl("media/img/icon/basic/play-circle.svg")}
                    alt="Gcc-law-help Presentation Document"
                  />
                </div>
                <div className="md:h-full md:w-full flex md:hidden md:items-center md:justify-center p-[5%]">
                  <img
                    className=""
                    src={toAbsoluteUrl("media/img/icon/basic/play-circle2.svg")}
                    alt="Gcc-law-help Video Document"
                  />
                </div>
              </div>
              <div className="w-full md:w-[80%] lg:w-[85%] sab-part2">
                <h3 className="flex items-center gap-3 mb-[.5%] sabp2-t1">
                  Video added in <span className="sabp2-t1-yellow">Misc</span>
                  <img
                    className="w-auto"
                    src={"media/img/icon/basic/YouTube.svg"}
                    alt=""
                  />
                </h3>
                <h2 className="mb-[3%] sabp2-t2">
                  Form 26AS Now Before Filling Your ITR
                </h2>
                <div className="w-full flex sm:flex-row flex-col gap-[10%] md:gap-[5%] lg:gap-[10%]">
                  <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                    <h4 className="sabp2-t3">Delivered At:</h4>
                    <h4 className="sabp2-t4">Lokmat</h4>
                  </div>
                  <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                    <h4 className="sabp2-t3">Date Of Publishing:</h4>
                    <h4 className="sabp2-t4">June 3, 2024</h4>
                  </div>
                  <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                    <h4 className="sabp2-t3">Author:</h4>
                    <h4 className="sabp2-t4">CA Umesh Sharma</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full md:w-[25%] lg:w-[20%] xl:w-[17%] flex items-center md:justify-between md:flex-col sab-part3">
              <div className="w-[50%] md:mt-[15%] md:w-full">
                <div className="w-auto sm:w-[20%] md:w-full md:justify-center flex gap-2  items-center">
                  <img
                    className="sabp3-t2"
                    src={toAbsoluteUrl("media/img/icon/basic/eye.svg")}
                    alt="Gcc-law-help View"
                  />
                  <h1 className="sabp3-t2">47</h1>
                </div>
              </div>
              <div className="w-[50%] md:w-full flex justify-end md:justify-center">
                <div className="w-max px-[3rem] py-[1rem] md:px-[3rem] md:py-[1rem] flex gap-2 items-center sabp3-btn justify-center">
                  <img
                    className="w-auto sabp3-t3"
                    src={toAbsoluteUrl("media/img/icon/basic/copy.svg")}
                    alt="Gcc-law-help Copy Link"
                  />
                  <h1 className="w-auto sabp3-t3">Copy Link</h1>
                </div>
              </div>
            </div>
          </div>
        ))} */}
        {articleList.length == 0
          ? <h1 className="not-exist-msg">{articleListEmptyMsg}</h1> || (
              <ArticleSkeleton />
            )
          : articleList.map((data) => (
              <div className="w-full lg:w-[90%] xl:w-[80%] p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sec-articles-box">
                <a
                  target="_blank"
                  href={data.articleDocument}
                  onClick={() => addVideoViewer(data.id)}
                  className="w-full md:w-[75%] lg:w-[80%] xl:w-[83%] flex gap-5 lg:gap-10"
                >
                  <div className="md:w-[20%] lg:w-[20%] xl:w-[15%] flex items-start md:items-center md:justify-center h-auto ">
                    <div className="sab-part1 md:h-full md:w-full hidden md:flex md:items-center md:justify-center p-[5%]">
                      <img
                        className=""
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/play-circle.svg"
                        )}
                        alt="Gcc-law-help Presentation Document"
                      />
                    </div>
                    <div className="md:h-full md:w-full flex md:hidden md:items-center md:justify-center p-[5%]">
                      <img
                        className=""
                        src={toAbsoluteUrl(
                          "media/img/icon/basic/play-circle2.svg"
                        )}
                        alt="Gcc-law-help Video Document"
                      />
                    </div>
                  </div>
                  <div className="w-full md:w-[80%] lg:w-[85%] sab-part2">
                    <h3 className="mb-[.5%] sabp2-t1">
                      Video added in{" "}
                      <span className="sabp2-t1-yellow">
                        {data.categoryName}
                      </span>
                    </h3>
                    <h2 className="mb-[3%] sabp2-t2">{data.title}</h2>
                    <div className="w-full flex sm:flex-row flex-col gap-[10%] sm:gap-[5%] xl:gap-[10%]">
                      <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                        <h4 className="sabp2-t3">Delivered at:</h4>
                        <h4 className="sabp2-t4">{data.deliveredAt}</h4>
                      </div>
                      <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                        <h4 className="sabp2-t3">Date of publishing:</h4>
                        <h4 className="sabp2-t4">{data.publishDate}</h4>
                      </div>
                      <div className="w-full flex sm:flex-col sm:w-max gap-2 sm:gap-0">
                        <h4 className="sabp2-t3">Author:</h4>
                        <h4 className="sabp2-t4">{data.author}</h4>
                      </div>
                    </div>
                  </div>
                </a>
                <div className="w-full md:w-[25%] lg:w-[20%] xl:w-[17%] flex items-center md:flex-col sab-part3">
                    <div className="w-[50%] flex gap-3 md:gap-5 md:mb-auto md:flex-col items-center md:w-full">
                      <a
                        href={data.articleDocument}
                        target="_blank"
                        onClick={() => addVideoViewer(data.id)}
                        className="w-auto md:w-max sabp3-t1"
                      >
                        View video
                      </a>
                      {auth && (
                        <div className="w-auto sm:w-[20%] md:w-full justify-center flex gap-2  items-center">
                          <img
                            className="sabp3-t2"
                            src={toAbsoluteUrl("media/img/icon/basic/eye.svg")}
                            alt="Gcc-law-help View"
                          />
                          <h1 className="sabp3-t2">{data.view}</h1>
                        </div>
                      )}
                    </div>
                    <div className="w-[50%] md:w-full flex justify-end md:justify-center">
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(data.articleDocument);
                          toastsuccessmsg("Link Copied.");
                        }}
                        className="w-max px-[3rem] py-[1rem] md:px-[3rem] md:py-[1rem] flex gap-2 items-center sabp3-btn justify-center"
                      >
                        <img
                          className="w-auto sabp3-t3"
                          src={toAbsoluteUrl("media/img/icon/basic/copy.svg")}
                          alt="Gcc-law-help Copy Link"
                        />
                        <h1 className="w-auto sabp3-t3">Copy link</h1>
                      </button>
                    </div>
                  </div>
                {/* <div className="w-full md:w-[25%] lg:w-[20%] xl:w-[17%] flex items-center md:justify-between md:flex-col sab-part3"> */}
                  {/* <div className="w-[50%] md:mt-[15%] md:w-full">
                    <div className="w-auto sm:w-[20%] md:w-full md:justify-center flex gap-2  items-center">
                      <img
                        className="sabp3-t2"
                        src={toAbsoluteUrl("media/img/icon/basic/eye.svg")}
                        alt="Gcc-law-help View"
                      />
                      <h1 className="sabp3-t2">{data.view}</h1>
                    </div>
                  </div> */}

                  {/* <div className="w-[50%] md:w-full flex justify-end md:justify-center">
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(data.articleDocument);
                        toastsuccessmsg("Link Copied.");
                      }}
                      className="w-max px-[3rem] py-[1rem] md:px-[3rem] md:py-[1rem] flex gap-2 items-center sabp3-btn justify-center"
                    >
                      <img
                        className="w-auto sabp3-t3"
                        src={toAbsoluteUrl("media/img/icon/basic/copy.svg")}
                        alt="Gcc-law-help Copy Link"
                      />
                      <h1 className="w-auto sabp3-t3">Copy Link</h1>
                    </button>
                  </div> */}
                {/* </div> */}
              </div>
            ))}
      </div>
    </>
  );
};

export default VideoList;
